import Screened from './Screened';

export default Screened;
